import request from '@/utils/request'

export default {
    getByEncryptId: function (encryptId) {
        return request({
            url: 'taolijin/getByEncryptId',
            method: 'post',
            params: {
                encryptId: encryptId,
            }
        });
    },
}